import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    contentContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    scrollView: {
        flex: 1
    }
});
export default stylesheet;
